import { useMemo } from 'react';

import { Select } from '../../../components/ui';
import type { FieldControlProps } from '../../../components/ui';
import { useT } from '../../../i18n';
import { luaChonThuMuc } from '../nghiep-vu/cay-thu-muc';
import type { Folder } from '../types';

/** Giá trị nội bộ của mục "Chưa phân loại" trong ô chọn — antd không nhận `null` làm giá trị lựa chọn. */
const GOC = '__goc__';

/**
 * Ô chọn một thư mục, thụt lề theo cây. `Select` phẳng chứ không `TreeSelect`: gõ để lọc chạy trên tên, và
 * danh sách vẫn đọc được khi cây sâu. Mục đầu là "Chưa phân loại" (`null`).
 *
 * `boNhanh` loại chính thư mục đó và con cháu — chuyển vào nhánh của mình là chu trình (server trả 400).
 */
export function ChonThuMuc({
  danhSach,
  giaTri,
  onChon,
  boNhanh,
  nhanGoc,
  ...con
}: Partial<FieldControlProps> & {
  danhSach: readonly Folder[];
  /** `null` là "Chưa phân loại" / gốc. */
  giaTri: string | null;
  onChon: (id: string | null) => void;
  boNhanh?: string;
  /** Nhãn của mục gốc: "Chưa phân loại" khi chọn chỗ cất tài liệu, "Ngoài cùng" khi chuyển thư mục. */
  nhanGoc: string;
}) {
  const { t } = useT();
  const luaChon = useMemo(() => luaChonThuMuc(danhSach, boNhanh), [danhSach, boNhanh]);

  return (
    <Select<string>
      {...con}
      className="w-full"
      showSearch={{ optionFilterProp: 'label' }}
      placeholder={t('baoCaoDoanhNghiep.thuMuc.chonThuMuc')}
      value={giaTri === null ? GOC : giaTri}
      onChange={(v) => onChon(v === GOC ? null : v)}
      options={[
        { value: GOC, label: nhanGoc },
        ...luaChon.map((n) => ({
          value: n.id,
          label: n.ten,
          // Thụt lề bằng padding của chính mục: nhãn (dùng để lọc) vẫn là tên trần.
          title: n.ten,
          style: { paddingInlineStart: `${12 + n.sau * 16}px` },
        })),
      ]}
    />
  );
}
